// Update variant picker option labels to show selected value
document.addEventListener('DOMContentLoaded', function() {
  // Function to update selected values in labels
  function updateSelectedValueLabels(variantPicker) {
    const optionLabels = variantPicker.querySelectorAll('[data-variant-picker-option-labels]');
    
    optionLabels.forEach(labelContainer => {
      const optionName = labelContainer.getAttribute('option-picker-name');
      const selectedValueSpan = labelContainer.querySelector('[data-selected-value]');
      
      if (selectedValueSpan) {
        // Find the selected pill or dropdown item
        const selectedPill = labelContainer.querySelector('.pill.selected .pill__label');
        const selectedDropdownItem = labelContainer.querySelector('.variant-picker-dropdown__item.selected span');
        
        if (selectedPill) {
          selectedValueSpan.textContent = selectedPill.textContent.trim();
        } else if (selectedDropdownItem) {
          selectedValueSpan.textContent = selectedDropdownItem.textContent.trim();
        }
      }
    });
  }
  
  // Initialize on page load
  const variantPickers = document.querySelectorAll('variant-picker');
  variantPickers.forEach(picker => {
    updateSelectedValueLabels(picker);
    
    // Listen for variant changes
    picker.addEventListener('change', () => {
      // Small delay to ensure DOM has updated
      setTimeout(() => {
        updateSelectedValueLabels(picker);
      }, 50);
    });
  });
  
  // Also listen for click events on pills
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('.pill');
    if (pill) {
      const variantPicker = pill.closest('variant-picker');
      if (variantPicker) {
        setTimeout(() => {
          updateSelectedValueLabels(variantPicker);
        }, 50);
      }
    }
  });
});
